export default __webpack_public_path__ + "static/media/PayWaveWhite.1f35affd.svg";